// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"d0ddab07","321":"136b272d","330":"4a873ab7","396":"2baa1643","421":"0b95a458","655":"d3e4275c"}[chunkId] + ".chunk.css";
};